<template>
	<div class="wrapper" id="home">
		<parallax class="section page-header header-filter" :style="headerStyle">
			<div class="container">
				<div class="md-layout header-section">
					<div
						class="md-layout-item md-size-100 md-small-size-70 md-xsmall-size-50 mx-auto text-center"
					>
						<h1 class="title" style="padding-top: 0px; font-size: 60px">
							Tan RongJun Daryl
						</h1>
						<h3 style="font-size: 20px; font-family: sans-serif">
							Year 3 Business Analytics Undergraduate<br />
							National University of Singapore<br />
							School of Computing
						</h3>
						<div class="socials">
							<md-card-actions class="text-center">
								<md-button
									href="https://www.linkedin.com/in/tan-daryl/"
									target="_blank"
									class="md-just-icon md-simple"
									id="header-icon"
								>
									<i class="fab fa-linkedin" id="header-icon"></i>
								</md-button>
								<md-button
									href="https://github.com/daryl-tan"
									target="_blank"
									class="md-just-icon md-simple"
									id="header-icon"
								>
									<i class="fab fa-github" id="header-icon"></i>
								</md-button>
							</md-card-actions>
						</div>
					</div>
				</div>
			</div>
		</parallax>
		<div class="main main-raised">
			<a class="anchor" id="about"></a>
			<section>
				<div class="section">
					<div class="container">
						<div class="md-layout">
							<div class="md-layout-item md-size-85 md-xsmall-size-100 mx-auto">
								<div class="grid-container">
									<div class="picture">
										<img
											:src="profilepic"
											class="img-raised rounded-circle img-fluid"
											style="max-width: 250px !important; margin-top: 65px"
										/>
									</div>

									<div class="details">
										<h3 class="title">About Me</h3>
										<p>
											I am currently a third year Business Analytics student at the National
											University of Singapore (NUS) School of Computing and I will be graduating in
											May 2023. Beyond the curriculum in school, I have an interest in Data
											Analytics as well as Digital Transformation.
										</p>
										<h3 class="title">Contact Me</h3>
										<p><b>Email:</b> tan.daryl@u.nus.edu</p>
										<p><b>Telegram:</b> @daryltannnn</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<a class="anchor" id="experience"></a>
			<section>
				<div class="section">
					<div class="container">
						<div class="md-layout">
							<div class="md-layout-item md-size-85 md-xsmall-size-100 mx-auto">
								<h3 class="title text-center sectionheader">Work Experience</h3>
								<div class="row">
									<div class="column one">
										<img
											src="https://media.glassdoor.com/sql/8450/pwc-squarelogo.png"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>PricewaterhouseCoopers</h4>
										<p>
											Risk Assurance - Data Trust Services Intern &bull; <i>May 2021 - Jul 2021</i>
										</p>
										<ul>
											<li>
												<p>
													Involved in project management in the Alliance for Action on Supply Chain Digitalization through creating a common data infrastructure
												</p>
											</li>
											<li>
												<p>
													Worked on a data governance project for a multinational company, helped set up end to end processes and create data mappings as part of data ingestion
												</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="row">
									<div class="column one">
										<img src="https://media.glassdoor.com/sql/337791/aia-group-squarelogo.png" />
									</div>
									<div class="column nine">
										<h4>AIA Singapore</h4>
										<p>
											Strategy &amp; Transformation - Enterprise Data Analytics Intern &bull;
											<i>Jan 2019 - May 2019</i>
										</p>
										<ul>
											<li>
												<p>
													Spearheaded company’s migration to Alteryx by using it to automate daily
													report preparation containing calculations for commission amount and sales
													figures through bancassurance, reducing preparation time from 5.5 hours to
													1 hour daily
												</p>
											</li>
											<li>
												<p>
													Involved in a data governance project and conceptualized a Tableau
													dashboard to present data quality metrics in the company
												</p>
											</li>
											<li>
												<p>
													Involved in a data warehouse migration project to check the accuracy
													between two data sources using Python Pandas Library. Presented and
													contributed the code to the Python community within the company
												</p>
											</li>
										</ul>
									</div>
								</div>
								<div class="row">
									<div class="column one">
										<img
											src="https://media.glassdoor.com/sql/301014/singapore-armed-forces-squarelogo-1536800644066.png"
											style="width: 70px"
										/>
									</div>
									<div class="column nine">
										<h4>Singapore Armed Forces</h4>
										<p>
											6th Singapore Infantry Regiment - Platoon Sergeant &bull;
											<i>Aug 2017 - Nov 2018</i>
										</p>
										<ul>
											<li>
												<p>
													Awarded the Best Commander Award on two separate occasions for outstanding
													performance in the battalion and was selected to attend the Company
													Sergeant Major Course
												</p>
											</li>
											<li>
												<p>
													Led a team of 8 men to facilitate the movement and flow of over 2500
													performers and 550 military personnel during NDP 2018, and was awarded the
													Best Performer of the Month award by the NDP Show Committee
												</p>
											</li>
											<li>
												<p>
													Effectively managed a platoon of 27 men and was accountable for their
													discipline, welfare and ability to meet the battalion’s operational needs
												</p>
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<a class="anchor" id="education"></a>
			<section>
				<div class="section">
					<div class="container">
						<div class="md-layout">
							<div class="md-layout-item md-size-85 md-xsmall-size-100 mx-auto">
								<h3 class="title text-center sectionheader">Education</h3>
								<div class="row">
									<div class="column one">
										<img
											src="https://media.glassdoor.com/sql/222778/national-university-of-singapore-squarelogo.png"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>National University of Singapore</h4>
										<p>
											Business Analytics (School of Computing) &bull; <i>Aug 2019 - May 2023</i>
										</p>
										<p>CAP: 4.31/5.00</p>
										<ul>
											<li>
												<p>
													University Town College Program - College of Alice and Peter Tan (CAPT) &bull; <i>Aug 2019 - May 2021</i>
												</p>
											</li>
											<li>
												<p>
													CAPT Student Action Leader Mentorship - Executive Member (Head of
													Logistics) &bull; <i>Aug 2020 - May 2021</i>
												</p>
												<ul>
													<li>
														<p>
															Planned and executed a mentorship program for 16 mentors from College of Alice and Peter Tan and 16 mentees from Tanglin Secondary School
														</p>
													</li>
													<li>
														<p>
															Acquired logistics for weekly mentoring sessions 
														</p>
													</li>
												</ul>
											</li>
											<li>
												<p>
													CAPT Sports Committee - Head of Dodgeball Interest Group &bull; <i>Aug 2020 - May 2021</i>
												</p>
												<ul>
													<li>
														<p>
															Organized a dodgeball competition for 30 students in the college, while abiding by Covid-19 restrictions and regulations to ensure the health and safety of participants 
														</p>
													</li>
													<li>
														<p>
															Planned and executed weekly training sessions for students in the college
														</p>
													</li>
												</ul>
											</li>
											<li>
												<p>
													NUS Varsity Table Tennis Team - Member &bull; <i>Aug 2019 - May 2023</i>
												</p>
												<ul>
													<li>
														<p>Represented NUS in Singapore University Games and Institute-Varsity-Polytechnic Games, clinching gold medals in both competitions</p>
													</li>
												</ul>
											</li>
											<li>
												<p>
													NUS School of Computing Sports Club - Member &bull; <i>Sep 2019 - May 2020</i>
												</p>
												<ul>
													<li>
														<p>Helped to organise a night cycling event for students in the School of Computing</p>
													</li>
												</ul>
											</li>
											
										</ul>
									</div>
								</div>
								<div class="row">
									<div class="column one">
										<img
											src="https://rafflesrampage.files.wordpress.com/2015/10/ri-new-crest.jpg?w=302&h=428"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>Raffles Institution</h4>
										<p>
											H2 Biology, H2 Chemistry, H2 Mathematics, H2 Economics, H1 General Paper, H1 Project Work &bull; <i>Jan 2011 - Dec 2016</i>
										</p>
										<p>
											U.A.P: 87.5/90
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<a class="anchor" id="skills"></a>
			<section>
				<div class="section">
					<div class="container">
						<div class="md-layout">
							<div class="md-layout-item md-size-85 md-xsmall-size-100 mx-auto">
								<h3 class="title text-center sectionheader">Skills</h3>
								<div class="row" style="display: flex; flex-direction: row; align-items: center">
									<div class="col text-center">
										<img src="../assets/img/python.png" style="height: 75px">
										<h5>Python</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/java.png" style="height: 75px">
										<h5>Java</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/r.jpg" style="height: 75px">
										<h5>R</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/informatica.png" style="height: 75px">
										<h5>Informatica</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/tableau.jpg" style="height: 75px">
										<h5>Tableau</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/alteryx.png" style="height: 75px">
										<h5>Alteryx</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/mysql.png" style="height: 75px">
										<h5>MySQL</h5>
									</div>
								</div>
								<div class="row" style="display: flex; flex-direction: row; align-items: center">
									<div class="col text-center">
										<img src="../assets/img/mongodb.jpg" style="height: 75px">
										<h5>MongoDB</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/vuejs.png" style="height: 75px">
										<h5>Vue.js</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/html.png" style="height: 75px">
										<h5>HTML</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/css.png" style="height: 75px">
										<h5>CSS</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/javascript.png" style="height: 75px">
										<h5>JavaScript</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/git.png" style="height: 75px">
										<h5>Git</h5>
									</div>
									<div class="col text-center">
										<img src="../assets/img/excel.jpg" style="height: 75px">
										<h5>Excel</h5>
									</div>
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<a class="anchor" id="projects"></a>
			<section>
				<div class="section">
					<div class="container">
						<div class="md-layout">
							<div class="md-layout-item md-size-85 md-xsmall-size-100 mx-auto">
								<h3 class="title text-center sectionheader">Projects</h3>
								<div class="row">
									<div class="column one">
										<img
											:src="MakanSaviorLogo"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>
											<a href="https://makansaviors.web.app/" target="_blank">MakanSaviors</a>
										</h4>
										<p>
											Development Team &bull; <i>2021</i>
										</p>
										<ul>
											<li>
												Created a web application using Vue.js to help redistribute excess food in Singapore as part of a module in school
											</li>
											<li>
												Part of the development team, driving the plan for each sprint. Responsible for planning, testing, coding and analysis throughout the course of the project
											</li>
										</ul>
									</div>
								</div>
								<div class="row">
									<div class="column one">
										<img
											:src="tulgan"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>
											<a href="https://tulgan.herokuapp.com/" target="_blank">TulGan</a>
										</h4>
										<p>
											Development Team &bull; <i>2020</i>
										</p>
										<ul>
											<li>
												Developed a chatbot using Python with the aim of answering queries of freshmen entering NUS Computing, as part of a module in school
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<a class="anchor" id="achievements"></a>
			<section>
				<div class="section">
					<div class="container">
						<div class="md-layout">
							<div class="md-layout-item md-size-85 md-xsmall-size-100 mx-auto">
								<h3 class="title text-center sectionheader">Achievements</h3>
								<div class="row">
									<div class="column one">
										<img
											src="https://careers.shopee.sg/codeleague/static/media/code_league_logo.24b5c5f8.svg"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>Shopee Code League 2021</h4>
										<p>
											Participation
										</p>
									</div>
								</div>
								<div class="row">
									<div class="column one">
										<img
											src="https://media-exp1.licdn.com/dms/image/C510BAQFQ90JJCDTtGw/company-logo_200_200/0/1521472728639?e=1633564800&v=beta&t=z8kxw4HrcAGl0r4wVDmYhkiZlnod7UaBSASBfzBNw2o"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>NUS Data Science Competition 2021</h4>
										<p>
											Participation
										</p>
									</div>
								</div>
								<div class="row">
									<div class="column one">
										<img
											src="https://seekvectorlogo.com/wp-content/uploads/2018/04/comfortdelgro-vector-logo.png"
											style="75px"
										/>
									</div>
									<div class="column nine">
										<h4>ComfortDelGro Hackathon 2019</h4>
										<p>
											Second Runner-Up 
										</p>
										<ul>
											<li>
												Collaborated with teammates to research and understand commuter’s behavior and proposed a technology-driven solution to encourage commuters to move to the rear of the bus
											</li>
											<li>
												Presented solution to board of directors, eventually achieving second runner-up in the competition
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
export default {
	bodyClass: "landing-page",
	props: {
		header: {
			type: String,
			default: require("@/assets/img/vue-mk-header.jpg"),
		},
		profilepic: {
			default: require("@/assets/img/profilepic.jpg"),
		},
		MakanSaviorLogo: {
			default: require("@/assets/img/MakanSaviorLogo.png"),
		},
		tulgan: {
			default: require("@/assets/img/tulgan.jpg"),
		},
	},
	computed: {
		headerStyle() {
			return {
				backgroundImage: `url(${this.header})`,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
a:link, a:visited {
	color: #11ABB0 !important
}

a:hover {
	color: black !important
}

p {
	font-size: 16px;
	line-height: 1.55em;
	margin-bottom: 15px;
}

h4 {
	font-size: 1.35rem;
	min-height: 32px;
	font-weight: 700;
	color: black;
	font-family: "Roboto Slab", "Times New Roman", serif;
}

.page-header {
	height: 110vh !important;
}

.section {
	padding: 15px 0;
}

a.anchor {
    display: block;
    position: relative;
    top: -35px;
    visibility: hidden;
}

.sectionheader {
	text-decoration: underline;
}

.socials {
	margin: 25px;
}

.title {
	color: black;
}

.grid-container {
	display: grid;
	grid-template-columns: 2fr 3fr;
	grid-gap: 20px;
}

.col {
	flex-basis: 0;
	flex-grow: 1;
	max-width: 100%;
}

#header-icon {
	color: white !important;
}

.md-button.md-fab i,
.md-button.md-fab,
.md-button.md-just-icon i,
.md-button.md-just-icon {
	font-size: 28px !important;
}

.row {
	margin-top: 10px;
}

.column {
	float: left;
	padding: 5px;
}

.one {
	width: 10%;
}

.two {
	width: 20%
}

.nine {
	width: 90%;
}

.row:after {
	content: "";
	display: table;
	clear: both;
}

.md-card-actions.text-center {
	display: flex;
	justify-content: center !important;
}

.md-has-textarea + .md-layout {
	margin-top: 15px;
}

@media screen and (max-width: 992px) {
	.header-image {
		display: none;
	}
}

</style>
